/* =============================================================================
   FG Square — custom JS
   Adds .fg-scrolled to the header once the page is scrolled, so the
   transparent-over-hero header turns solid porcelain.
   ============================================================================= */
(function () {
  function setup() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 40) header.classList.add('fg-scrolled');
      else header.classList.remove('fg-scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);
})();

/* Relabel the Refund policy page heading -> "Return Policy" (that page only). */
(function () {
  if (location.pathname.indexOf('/policies/refund-policy') !== 0) return;
  function relabel() {
    var h = document.querySelector('h1, .page-title, .rte h1');
    if (h && /refund policy/i.test(h.textContent)) h.textContent = 'Return Policy';
    if (/refund policy/i.test(document.title)) document.title = document.title.replace(/refund policy/i, 'Return Policy');
  }
  if (document.readyState !== 'loading') relabel();
  else document.addEventListener('DOMContentLoaded', relabel);
})();

/* Collection-grid "Add to cart": AJAX add, update ONLY the header cart count,
   never navigate to /cart. Scoped to product-card grid buttons so the product
   page / quick-view behavior is left untouched. Runs in the capture phase so it
   pre-empts the theme's own document handler (which would redirect to /cart). */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  function refreshCount() {
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-btn-addtocart], .button-ATC');
    if (!btn || btn.tagName === 'A') return;                    // ignore "select options"/quick-shop links
    // Resolve the form: nearest ancestor form, OR the one referenced by
    // data-form-id (the Pre-order / add buttons reference the form this way, which
    // is exactly the case that used to fall through to the theme's broken handler).
    var form = btn.closest('form.variants[data-product-id]');
    if (!form && btn.getAttribute('data-form-id')) {
      try { form = document.querySelector(btn.getAttribute('data-form-id')); } catch (err) { form = null; }
    }
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;                     // needs a resolved variant

    // Skip PRE-ORDER products: the PreOrder Bat (Globo) app owns those buttons and
    // runs its own add flow + spinner. Intercepting them blocks the app, leaving its
    // spinner stuck forever. Detect by the button's label only. (window.preOrderObj
    // is NOT a pre-order flag: the app fills it with stock counts for every product,
    // so checking it sent every Halloween piece down the slow redirect-to-cart path.)
    var btnText = (btn.textContent || '').trim().toLowerCase();
    var isPreorder = btnText.indexOf('pre-order') !== -1 || btnText.indexOf('preorder') !== -1 || btnText.indexOf('pre order') !== -1;
    if (isPreorder) return;                                  // hand off to the pre-order app

    e.preventDefault();
    e.stopImmediatePropagation();                            // block the theme's redirect + its spinner-that-never-clears

    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = (qtyEl && qtyEl.value) ? parseInt(qtyEl.value, 10) : 1;
    if (!qty) qty = 1;
    btn.classList.add('is-loading');
    // Hard safety: never let the spinner run more than 6s, no matter what.
    var safety = setTimeout(function () { btn.classList.remove('is-loading'); }, 6000);

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: idInput.value, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCount(); })
      .catch(function () {})
      .then(function () { clearTimeout(safety); btn.classList.remove('is-loading'); });
  }, true);

  // Watchdog: clear any Add-to-Cart spinner that's been stuck too long (belt-and-
  // suspenders for any edge case where a stray handler leaves one spinning).
  setInterval(function () {
    var now = Date.now();
    document.querySelectorAll('.button-ATC.is-loading, [data-btn-addtocart].is-loading').forEach(function (b) {
      var since = parseInt(b.getAttribute('data-atc-since') || '0', 10);
      if (!since) { b.setAttribute('data-atc-since', now); return; }
      if (now - since > 6000) { b.classList.remove('is-loading'); b.removeAttribute('data-atc-since'); }
    });
    document.querySelectorAll('[data-atc-since]').forEach(function (b) {
      if (!b.classList.contains('is-loading')) b.removeAttribute('data-atc-since');
    });
  }, 1500);
})();

/* Footer: remove the "Social Media" item from the #FGSQUARE menu (admin 'fgsquare'
   linklist, so it can't be edited from theme files — strip it on render instead). */
(function () {
  function strip() {
    var scope = document.querySelector('#shopify-section-footer-02')
             || document.querySelector('footer')
             || document.querySelector('.footer')
             || document;
    scope.querySelectorAll('a').forEach(function (a) {
      if ((a.textContent || '').trim().toLowerCase() === 'social media') {
        (a.closest('li') || a).remove();
      }
    });
  }
  if (document.readyState !== 'loading') strip();
  else document.addEventListener('DOMContentLoaded', strip);
})();

/* Footer CATEGORIES: repoint the "Christmas Villages" / "Halloween Villages"
   links (admin 'categories' menu, still pointing at old collections) to the
   current collections. */
(function () {
  var MAP = {
    'christmas villages': '/collections/fg-christmas-villages',
    'halloween villages': '/collections/fg-square-halloween-village'
  };
  function fix() {
    var scope = document.querySelector('#shopify-section-footer-02')
             || document.querySelector('footer') || document.querySelector('.footer') || document;
    scope.querySelectorAll('a').forEach(function (a) {
      var t = (a.textContent || '').trim().toLowerCase();
      if (MAP[t]) a.setAttribute('href', MAP[t]);
    });
  }
  if (document.readyState !== 'loading') fix();
  else document.addEventListener('DOMContentLoaded', fix);
})();

